
    import { makeI18n } from '@/shared/lib/i18n';
    const baseTranslation = undefined
    
    
    if(module.hot) {
      const bucket = require("/app/build/i18n/browser-bucket.js");
      bucket.add('src/components/email-verification/parts/email-status-banner.vue', {"email.status.login":{"ru_RU":"Рабочая почта для входа не&nbsp;подтверждена","en_US":"Work email for log in is not&nbsp;confirmed"},"email.status.notification":{"ru_RU":"Почта для уведомлений не&nbsp;подтверждена","en_US":"Email for notifications is not confirmed"},"link":{"ru_RU":"Подтвердить почту","en_US":"Confirm email"}}) 
    }
   
    
    export default function (Component) {
      function beforeCreateI18n() {
        this.$i18n = this.$options._i18n;
      }

      function addHook(current) {
        if (Array.isArray(current)) {
          return [beforeCreateI18n].concat(current);
        } 
        if (current) {
          return [beforeCreateI18n, current];
        }
        return [beforeCreateI18n];
      }
    
      Component._i18n = makeI18n("src/components/email-verification/parts/email-status-banner.vue", baseTranslation);
      Component.beforeCreate = addHook(Component.beforeCreate);
      delete Component._Ctor;
    }
  